import React from 'react';

/* ITSM logo icon — blue ticket + gear/check + headset, recreated as inline SVG.
   Used in the login page, sidebar header, and as a page watermark.
   `idSuffix` keeps the gradient id unique when multiple icons render at once. */
export default function ItsmIcon({ size = 120, idSuffix = '', style }) {
  const gid = `itsmTicket${idSuffix}`;
  const teeth = Array.from({ length: 8 }, (_, i) => i * 45);
  return (
    <svg width={size} height={size * 0.66} viewBox="0 0 160 106" fill="none" style={style}>
      <defs>
        <linearGradient id={gid} x1="40" y1="20" x2="150" y2="92" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#1e3a8a" />
          <stop offset="0.55" stopColor="#1d6fd0" />
          <stop offset="1" stopColor="#38bdf8" />
        </linearGradient>
      </defs>
      <g transform="rotate(-9 90 56)">
        {/* motion dashes */}
        <g fill={`url(#${gid})`}>
          <rect x="2"  y="40" width="36" height="8" rx="4" />
          <rect x="12" y="56" width="44" height="8" rx="4" />
          <rect x="26" y="72" width="30" height="8" rx="4" />
          <circle cx="6" cy="60" r="4" />
          <circle cx="20" cy="44" r="4" />
        </g>
        {/* ticket body */}
        <path d="M52 28 H146 a8 8 0 0 1 8 8 V48 a8 8 0 0 0 0 16 V76 a8 8 0 0 1 -8 8 H52 a8 8 0 0 1 -8 -8 V36 a8 8 0 0 1 8 -8 Z"
          fill={`url(#${gid})`} />
        {/* perforation */}
        <line x1="118" y1="30" x2="118" y2="82" stroke="#fff" strokeWidth="2.4"
          strokeDasharray="3 5" strokeLinecap="round" opacity="0.92" />
        {/* star + lines on stub */}
        <path d="M134 40 l2.2 4.6 5 0.5 -3.7 3.4 1 5 -4.5 -2.5 -4.5 2.5 1 -5 -3.7 -3.4 5 -0.5 Z" fill="#fff" />
        <g stroke="#fff" strokeWidth="2.4" strokeLinecap="round" opacity="0.92">
          <line x1="128" y1="60" x2="146" y2="60" />
          <line x1="128" y1="67" x2="142" y2="67" />
        </g>
        {/* headset arc + ear pads + mic */}
        <g stroke="#fff" strokeWidth="4.4" fill="#fff" strokeLinecap="round">
          <path d="M68 56 a18 18 0 0 1 36 0" fill="none" />
          <rect x="64" y="54" width="7" height="15" rx="3.5" stroke="none" />
          <rect x="101" y="54" width="7" height="15" rx="3.5" stroke="none" />
          <path d="M104 67 v4 a6 6 0 0 1 -6 6 H88" fill="none" strokeWidth="3.4" />
        </g>
        {/* gear */}
        <g fill="#fff">
          {teeth.map(a => (
            <rect key={a} x="84.5" y="38" width="3" height="7" rx="1.4"
              transform={`rotate(${a} 86 56)`} />
          ))}
          <circle cx="86" cy="56" r="13" fill="#fff" />
          <circle cx="86" cy="56" r="8.5" fill={`url(#${gid})`} />
          <path d="M82 56 l3 3 5.5 -6" stroke="#fff" strokeWidth="2.6" fill="none"
            strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </g>
    </svg>
  );
}
